<template>
  <div
    class="canvas-panel">
    <div
      v-if="isRulerOn"
      :style="getHSStyle">
      <vue-guides
        ref="hGuides"
        :unit="getRulerUnit"
        :text-offset="[0,10]"
        :zoom="getRulerZoom"
        :show-guides="true"
        :display-drag-pos="true"
        :digit="getDigit"
        :guide-style="getHorizontalGuideStyle"
        :snaps="loadVerticalSnapPoints"
        :snap-threshold="7"
        type="horizontal"
        height="20"
        @changeGuides="onChangeGuides"
      />
    </div>
    <div
      v-if="isRulerOn"
      style="width: 20px; position:absolute; top: 20px; left: 0; bottom: 0; z-index: 50 ">
      <vue-guides
        ref="vGuides"
        :zoom="getRulerZoom"
        :text-offset="[10,0]"
        :unit="getRulerUnit"
        :show-guides="true"
        :display-drag-pos="true"
        :digit="getDigit"
        :guide-style="getVerticalGuideStyle"
        :snaps="loadHorizontalSnapPoints"
        :snap-threshold="7"
        type="vertical"
        width="20"
        @changeGuides="onChangeGuides"

      />

    </div>
    <div
      class="pagination-section updated-flex pt-32 text-center pb-32"
      @click="clearAllSelection">
      <ul class="mb-0 d-flex pagination-list list-unstyled justify-content-center">
        <div
          class="zoom-button-section d-flex align-items-center justify-content-center"
          @click="clearAllSelection">
          <a
            role="button"
            class="pagination-pill d-flex justify-content-center rounded-4 bg-white me-12 hover-icon tooltip-button"
            @click="zoomInCanvas">
            <icon name="zoomin"/>
          </a>
          <a
            role="button"
            class="pagination-pill d-flex justify-content-center rounded-4 bg-white me-12 hover-icon tooltip-button"
            @click="zoomOutCanvas">
            <icon name="zoomout"/>
          </a>
          <a
            role="button"
            class="pagination-pill d-flex justify-content-center rounded-4 bg-white me-0  tooltip-button enable-zoom"
            @click="resetZoom">
            <icon name="zoomdisable"/>
          </a>
        </div>
        <div
          v-if="isVideoMoodOn"
          :class="[
            getDisplayAnimationPanel ? 'selected-animation' : '',
            activeObject ? '' : 'pe-none',
            activeObject ? '' : 'opacity-dim',]"
          class="pagination-button-wrapper me-8 d-flex flex-row animation-button"
          @click.stop="toggleAnimationTray">
          <icon name="animation"/>
          <button class="bg-transparent border-0 me-8">
            Animate
          </button>
        </div>
      </ul>
    </div>
    <div
      id="canvas-section"
      ref="canvasSection"
      :key="rerenderer"
      :style="getStyle"
      class="canvas-section scroller overflow-auto  position-relative"
      @scroll="savePageScroll"
    >

      <div
        v-show="!$store.getters['activeProduct/getShowVideoPanel']"
        id="canvas-wrapper"
        ref="canvasWrapper"
        :style="getCanvasWrapperStyle"
        style="z-index:1;"
        class="canvas-wrapper overflow-hidden position-absolute canvas-non-play-all"
        @click.stop="canvasWrapper">
        <canvas-section
          :height="getSelectedPageHeight"
          :width="getSelectedPageWidth"
          :base-image="baseImage"
          :scale="getZoom"
          :content-list="contentList"
          :active-page="activePage"
          :product-crop="productCrop"
          :product-scale="productScale"
          :is-gray-scale-on="isGrayScaleOn"
          :is-fake-rendering="false"
          :rendering-order="0"

        />
      </div>
      <div
        v-show="$store.getters['activeProduct/getShowVideoPanel']"
        :style="getCanvasWrapperStyle"
        style="left:50%; overflow:hidden"
        class="canvas-video-wrapper position-absolute pe-none">
        <div class="position-relative w-100 h-100">
          <div
            v-for="(pageNumber, index) in getProductPages"
            v-show="$store.getters['activeProduct/getShowVideoPanel']"
            :key="index"
            :starttime="pageNumber.animation && pageNumber.animation.startTime ? pageNumber.animation.startTime : 0"
            :duration="pageNumber.animation && pageNumber.animation.duration ? pageNumber.animation.duration : 5.000"
            :class="[
              'page-id-' + index,
              'page-' + index,
              product.transitions && product.transitions.length && product.transitions[index-1 >=0 ? index-1 : 0] && product.transitions[index-1 >=0 ? index-1 : 0].name.includes('transitionPan')? 'translate-0-imp': '',
              product.transitions && product.transitions.length && product.transitions.length == index-1  && product.transitions[index-1] && product.transitions[index-1].name.includes('transitionPan') ? 'translate-0-imp': '']"
            :id="'page-id-' + index"
            :style="getCanvasWrapperStyleVideo"
            class="canvas-wrapper overflow-hidden position-absolute canvas-animation-page "
            @click.stop="onCanvasClickToStopAnimation">
            <div
              :id="'main_page_div' + index"
              :style="getWraperDivStyle(pageNumber)"
              class="html-container canvas-main-html-container"
            >
              <component
                v-for="(object, index) in pageNumber.objectList"
                :is="object.type + '-object'"
                :element-index="index"
                :data-pageindex="object.PageIndex"
                :key="object.Id"
                :data="object"
                :object-props="object"
                :scale="zoom"
                :is-fake-rendering="false"
                :display-controls="true"
                :isAnimationInProgress="true"
              />
            </div>
          </div>
        </div>
      </div>


      <!--        TODO: Review getBaseImageForCanvas-->

      <!--                  :base-image="getBaseImageForCanvas"-->
    </div>
    <div
      v-show="!getIsTrimmingEnable && !$store.getters['activeProduct/getIsAudioTrimOn']"
      id="thumbnail-scroller"
      :class="isVideoMoodOn ? '' : 'static-pages'"
      class="pagination-section scroller overflow-auto text-center thumbnail-area mt-20 addition-setting"
      @scroll="updatedScrollingValue">
      <ul
        id="thumbnail-timeline"
        :style="getThumbnailScrollerStyle"
        class="mb-0 d-flex pagination-list list-unstyled overflow-auto align-items-center">
        <div
          v-show="!$store.getters['activeProduct/getIsAnimationInProgress'] && isVideoMoodOn"
          class="play-btn"
          @click.stop="playAllAnimationOnCanvas()">
          <icon name="playButton"/>
        </div>
        <div
          v-show="$store.getters['activeProduct/getIsAnimationInProgress'] && isVideoMoodOn"
          class="play-btn"
          @click.stop="pauseVideoOnCanvas">
          <icon name="pause"/>
        </div>

        <div
            v-if="isVideoMoodOn"
            :style="getTranslateX"
            :class="{ grabbing: isMouseDown }"
            @mousedown="onMouseDown"
            class="d-flex progress-bar-wrapper"
        >
          <div class="d-flex" style="position: absolute;top: -17px;left: -7px;">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
              <path d="M0 0H12V8.5L7 13H6H5L0 8.5V0Z" fill="#000000" />
            </svg>
          </div>
          <div class="slider-line" style="height: 78px; width: 3px"/>
        </div>
        <draggable
          :disabled="!dragging"
          v-model="productPages"
          :move="onDragMove"
          class="d-flex slides-wrapper"
          group="people"
        >
          <div
            v-for="(pageNumber, index) in getProductPagesForThumbnail"
            :key="index"
            :style="getParentDivThumbnailStyle1"
            class="d-flex align-items-center"
            @click.stop="changeProductPage(index+1)"
          >
            <div
              :id="'page-' + index"
              :style="getParentDivThumbnailStyle(pageNumber)"
            >
              <div
                :style="getThumbnailStyle(index)"
                class="pagination-button-wrapper position-relative overflow-hidden">
                <div
                  v-if="isVideoMoodOn && !isDragging"
                  class="container-trim">
                  <button
                    :id="'trim-left-' + index"
                    class="trim left"
                    @click.stop
                    @mouseenter="onMouseEnter"
                    @mouseleave="onMouseLeave"
                    @mousedown.self="resizePageWidthStart"
                    @mouseup.stop="toggleMouseUpVariable">I
                  </button>
                </div>
                <div
                  :style="calculateDimensions(pageNumber)"
                  class="position-absolute border-7 overflow-hidden svg-img-shapes">
                  <div
                    :style="getHTMLStyle(pageNumber)"
                    :id="'main_page_di'+index"
                    class="overflow-hidden d-block position-absolute"
                  >
                    <component
                      v-for="(object,index) in pageNumber.objectList"
                      :is="object.type+'-object'"
                      :element-index="index"
                      :data-pageindex="object.PageIndex"
                      :key="object.Id"
                      :data="object"
                      :object-props="object"
                      :scale="zoom"
                      :is-fake-rendering="true"
                      :display-controls="true"/>
                  </div>
                </div>
                <span
                  v-if="isVideoMoodOn"
                  :id="'duration-' + index"
                  class="page-duration">{{ getPageDuration(pageNumber) }}</span>
                <span
                  v-show="activePage===index"
                  :class="displayThumbnailOptions ? 'box-shadow-3dots': ''"
                  class="dotted-dd"
                  @click.stop="showThreeDots">
                  <span class="dot"/>
                  <span class="dot"/>
                  <span class="dot"/>
                </span>
                <div
                  v-if="isVideoMoodOn && !isDragging"
                  class="container-trim">
                  <button
                    :id="'trim-right-' + index"
                    class="trim right"
                    @click.stop
                    @mouseenter="onMouseEnter"
                    @mouseleave="onMouseLeave"
                    @mousedown.self="resizePageWidthStart"
                    @mouseup.stop="toggleMouseUpVariable">I
                  </button>
                </div>
              </div>
            </div>
            <div v-if="isVideoMoodOn">
              <div
                v-if="transitionIconToShow(index)"
                :id="index"
                :class="{ 'full-opacity': $store.getters['activeProduct/getPageAnimationIndex'] == index && !isDragging }"
                class="transition-icon d-flex"
                @click.stop="addTransitionToPage(index)">
                <icon name="transition-icon"/>
              </div>
            </div>
            <div
              v-show="activePage===index && displayThumbnailOptions"
              :style="threeDotsApperance(index)"
              class="dots-popup-menu position-absolute">
              <ul>
                <li
                  v-if="isVideoMoodOn && product.transitions && index < product.transitions.length "
                  @click.stop="addTransitionToPage(index)">
                  <icon name="transition"/>
                  <span class="m-3">Add Transition</span>
                </li>
                <li @click.stop="onProductPageDuplicate(pageNumber)">
                  <icon name="copied"/>
                  <span class="m-3">Duplicate</span>
                </li>
                <li
                  v-if="product.pages.length > 1"
                  @click.stop="deleteCurrentProductPage">
                  <icon name="trash"/>
                  <span class="m-3">Delete</span>
                </li>
              </ul>
              <div
                class="closer"
                @click.stop="displayThumbnailOptions = false"/>
            </div>
          </div>
        </draggable>
        <div
          :style="getAddNewPageBtnStyle"
          class="pagination-button-wrapper me-8 page-plus">
          <button
            class="icon-btn custom-icon pagination-pill d-flex align-items-center justify-content-center hover-icon rounded rounded-4 py-0 px-10 border-0 btn-outline-0 pagination-buttons"
            @click.stop="onProductNewPageCreate">
            <icon name="page-plus"/>
          </button>
        </div>
      </ul>
      <div
        v-if="isVideoMoodOn && !$store.getters['activeProduct/getIsAudioTrimOn']"
        class="d-flex align-items-center position-fixed timeline-duration"
      >{{ nanosecondsToTimeFormat }}/{{ getTotalDurationInFormat }}
      </div>
    </div>
    <div
      v-if="getIsTrimmingEnable && activeObject.type == 'video' && !$store.getters['activeProduct/getIsAudioTrimOn']"
      class="position-absolute bottom-0 align-items-center pagination-section text-center thumbnail-area mt-20 trim-parent">
      <div class="d-flex">
        <div
          v-show="!isTrimmedVideoPlaying"
          class="trim-btn"
          @click.stop="playSelectedVideo">
          <icon name="playButton"/>
        </div>
        <div
          v-show="isTrimmedVideoPlaying"
          class="trim-btn"
          @click.stop="stopSelectedVideo">
          <icon name="stop"/>
        </div>
      </div>
      <div class="trimming-container">
        <div class="strip d-flex position-relative">
          <film-strip
            :src="getVideoURL"
            :elem="activeObject.Id"
            :height="84"
            :max-width="getTrimBarWidth"
            :count="16"/>
          <div class="wrapper">
            <div class="container-trimming">
              <div
                :style="getTrimStartStyle"
                class="startTime trim-overlay"/>
              <div
                :style="getTrimEndStyle"
                class="endTime trim-overlay"/>
              <div
                :style="getTrimBarTranslateX"
                class="d-flex trim-bar position-absolute">
                <div style="height: 78px; width: 3px"/>
              </div>
              <div
                :style="getTrimTimeLineStartStyle"
                class="trim-timeline-start trim-timeline">{{ parseFloat(this.sliderOne).toFixed(2) }}
              </div>
              <div
                :style="getTrimTimeLineEndStyle"
                class="trim-timeline-end trim-timeline">{{ parseFloat(this.sliderTwo).toFixed(2) }}
              </div>
              <input
                id="slider-1"
                :min="0"
                :max="getMaxValue"
                v-model="sliderOne"
                type="range"
                step="0.001"
                @input="slideOne">
              <input
                id="slider-2"
                :min="0"
                :max="getMaxValue"
                v-model="sliderTwo"
                type="range"
                step="0.001"
                @input="slideTwo">
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex">
        <div
          class="trim-btn"
          @click.stop="trimVideo">DONE
        </div>
      </div>
      <div class="position-fixed trim-duration">
        {{ getTotalTimeDuration }}s
      </div>
    </div>

    <wave-surfer
      v-if="$store.getters['activeProduct/getIsAudioTrimOn']"
      :product="product"
      :width="parseInt(canvasPanelWidth)"
    />

    <audio
      v-if="product && product.audioDetails && product.audioDetails.audioUrl"
      id="canvas-audio"
      ref="canvasaudio"
      controls
      class="">
      <source
        :src="product.audioDetails ? product.audioDetails.audioUrl : ''"
        type="audio/mp3">
    </audio>

    <preview-modal
      v-if="$store.getters['getDisplayPreviewModal']"
      :product="product"
      :is-gray-scale-on="isGrayScaleOn"
    />
  </div>
</template>
<script>

import Scalepopup from '@/components/Scalepopupbox/Scalepopupbox.vue';
import Canvas from '@/components/Canvas/Canvas.vue';
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';
import Guides from 'vue-guides';
import ElementAnimationMixin from '@/mixins/ElementAnimation';
import CanvasPanelMixin from '@/mixins/CanvasPanelMixin';
import {
  Text, Image as ImageObj, Path, Video,
} from '@/components/CanvasShapes';
import FilmStrip from '@/components/FilmStrip/FilmStrip';
import WaveSurferComponent from '@/components/WaveSurferComponent/WaveSurferComponent';
import draggable from 'vuedraggable';
import PreviewModal from '../PreviewModal/PreviewModal.vue';

export default {
  name:       'CanvasPanel',
  components: {
    'Scalepopup-tag': Scalepopup,
    'canvas-section': Canvas,
    'vue-guides':     Guides,
    'text-object':    Text,
    'shape-object':   Path,
    'image-object':   ImageObj,
    'video-object':   Video,
    'preview-modal':  PreviewModal,
    'film-strip':     FilmStrip,
    'wave-surfer':    WaveSurferComponent,
    draggable,
  },
  mixins: [ElementAnimationMixin, CanvasPanelMixin],
  props:  {
    product:            Object,
    activeObject:       Object,
    contentList:        { Object, Array },
    width:              Number,
    height:             Number,
    activePage:         Number,
    ProductPagesLength: Number,
    baseImage:          String,
    productCrop:        Object,
    isRulerOn:          Boolean,
    productScale:       Array,
    isGrayScaleOn:      Boolean,
    isAlignmentGuideOn: Boolean,
    dragTarget:         document.querySelector('#drag-button'),

  },

  data() {
    return {
      change:                    0,
      isMounted:                 false,
      zoomLevel:                 100,
      actualZoomLevel:           100,
      zoomToFitLevel:            100,
      zoom:                      1,
      productWidth:              this.width,
      productHeight:             this.height,
      rulerUpdated:              false,
      horizontalScroll:          0,
      verticalScroll:            0,
      canvasLeft:                0,
      positionOffset:            { x: 0, y: 0 },
      horizontalSnapPoints:      [],
      verticalSnapPoints:        [],
      displayThumbnailOptions:   false,
      mouseDown:                 false,
      currentWidth:              null,
      page:                      null,
      selectedThumbnailId:       null,
      productDuration:           0,
      elapsedTime:               0,
      canvasPanelWidth:          0,
      timeLine:                  0,
      interval:                  null,
      productTimeLineWidth:      0,
      thumbnailScroller:         null,
      threeDotLeft:              0,
      threeDotTop:               0,
      scrollerWidthOffset:       160,
      threeDotsLeftOffset:       344,
      threeDotsTopOffset:        280,
      pagesScroll:               null,
      timeLineOffset:            0,
      rerenderer:                0,
      sliderOne:                 0,
      sliderTwo:                 0,
      minGap:                    0,
      selectedVideo:             null,
      selectedAudio:             null,
      trimBar:                   0,
      trimBarTransition:         '',
      trimInterval:              null,
      videoObjPlayingTiemouts:   [],
      selectedPageFutureIndex:   0,
      selectedPagePreviousIndex: 0,
      dragging:                  true,
      isMouseDown: false,
      isDragging: false,
      startX:false
    };
  },

  computed: {
    getTotalDurationInFormat() {
      const totalSeconds     = this.productDuration;
      const minutes          = Math.floor(totalSeconds / 60);
      const seconds          = totalSeconds % 60;
      const formattedMinutes = (minutes < 10) ? `0${minutes}` : minutes;
      const formattedSeconds = (seconds < 10) ? `0${parseInt(seconds)}` : parseInt(seconds);
      return `${formattedMinutes}:${formattedSeconds}`;
    },
    nanosecondsToTimeFormat() {
      const totalSeconds     = this.played;
      const minutes          = Math.floor(totalSeconds / 60);
      const seconds          = totalSeconds % 60;
      const formattedMinutes = (minutes < 10) ? `0${minutes}` : minutes;
      const formattedSeconds = (seconds < 10) ? `0${parseInt(seconds)}` : parseInt(seconds);
      return `${formattedMinutes}:${formattedSeconds}`;
    },
    getParentDivThumbnailStyle1() {
      const newStyle = {
        borderRadius: '9px',
        overflow:     'visible',
      };
      return newStyle;
    },
    isVideoMoodOn() {
      return this.$store.getters['activeProduct/getIsVideoMoodOn'];
    },
    getDisplayAnimationPanel() {
      let display = true;
      if (this.activeObject && this.activeObject.ImageType && (this.activeObject.ImageType.includes('FDIC') || this.activeObject.ImageType.includes('WhiteboxLogo'))) {
        display = false;
      }
      return this.$store.getters['activeProduct/getDisplayAnimationPanel'] && display;
    },
    getTrimBarTranslateX() {
      const style = {
        left:       `${(this.trimBar)}px`,
        transition: `${this.trimBarTransition}`,
      };
      console.log(style);
      return style;
    },
    getTotalTimeDuration() {
      const duration            = parseFloat(this.activeObject.videoDetails.duration).toFixed(3);
      const durationInFloat     = parseFloat(duration);
      const sliderOne           = parseFloat(this.sliderOne).toFixed(3);
      const sliderOneInFloat    = parseFloat(sliderOne);
      const sliderTwo           = parseFloat(this.sliderTwo).toFixed(3);
      const sliderTwoInDuration = duration - parseFloat(sliderTwo);
      return parseFloat(durationInFloat - sliderOneInFloat - sliderTwoInDuration).toFixed(3);
    },
    getTrimBarWidth() {
      return this.canvasPanelWidth - 150;
    },
    isTrimmedVideoPlaying() {
      return this.$store.getters['activeProduct/getIsTrimmedVideoPlaying'];
    },
    getTrimStartStyle() {
      const newStyle = {
        width: `${this.sliderOne * ((this.canvasPanelWidth - 150) / parseFloat(this.activeObject.videoDetails.duration).toFixed(2))}px`,
      };
      return newStyle;
    },
    getTrimTimeLineStartStyle() {
      const newStyle = {
        left: `${(this.sliderOne * ((this.canvasPanelWidth - 150) / parseFloat(this.activeObject.videoDetails.duration).toFixed(2))) - 10}px`,
      };
      return newStyle;
    },
    getTrimEndStyle() {
      const newStyle = {
        width: `${(this.canvasPanelWidth - 150) - (this.sliderTwo * ((this.canvasPanelWidth - 150) / parseFloat(this.activeObject.videoDetails.duration).toFixed(2)))}px`,
      };
      return newStyle;
    },
    getTrimTimeLineEndStyle() {
      const newStyle = {
        right: `${((this.canvasPanelWidth - 150) - (this.sliderTwo * ((this.canvasPanelWidth - 150) / parseFloat(this.activeObject.videoDetails.duration).toFixed(2)))) - 10}px`,
      };
      return newStyle;
    },
    getMaxValue() {
      return this.activeObject && parseFloat(this.activeObject.videoDetails.duration).toFixed(2);
    },
    getSliderGap() {
      if (this.activeObject && this.activeObject.videoDetails.duration) {
        return (6 / 100) * parseFloat(this.activeObject.videoDetails.duration).toFixed(2);
      }
    },
    getVideoURL() {
      return this.activeObject && this.activeObject.videoDetails.VideoSourceUrl;
    },
    getIsTrimmingEnable() {
      if (!this.activeObject) {
        return;
      }
      if (this.$store.getters['activeProduct/getIsTrimmingEnable']) {
        this.sliderOne = this.activeObject.videoDetails.startTime;
        if (this.activeObject.videoDetails.endTime) {
          this.sliderTwo = this.activeObject.videoDetails.endTime;
        } else {
          this.sliderTwo = this.activeObject.videoDetails.duration;
        }
      }
      return this.$store.getters['activeProduct/getIsTrimmingEnable'];
    },
    getAddNewPageBtnStyle() {
      const style = {
        marginLeft: this.isVideoMoodOn ? '20px' : '0',
      };
      return style;
    },
    getThumbnailScrollerStyle() {
      const newStyle = {
        width:     `${this.thumbnailScroller + this.scrollerWidthOffset}px`,
        overflowX: 'scroll',
        paddingTop: '20px'
      };
      return newStyle;
    },
    getTranslateX() {
      const style = {
        transform: `translateX(${(this.timeLine)}px)`,
        marginLeft: '60px',
        zIndex: 1000,
        cursor: 'grab'
      };
      return style;
    },
    isPageHasAnimation() {
      return this.contentList.some(element => element.isAnimated === true);
    },
    loadVerticalSnapPoints() {
      if (this.contentList.length < 1) {
        return [];
      }
      const elem = this.contentList;
      const sd   = [];
      elem.forEach((item) => {
        let itemTop    = item.Y;
        let itemBottom = item.Y + item.Height;
        if (item.type == 'text') {
          const normalHeight = item.Height;
          const scaledHeight = item.Height * item.scaleX;
          itemTop            = item.Y - (scaledHeight - normalHeight) / 2;
          itemBottom         = itemTop + (item.Height * item.scaleX);
        }
        const top    = (itemTop / (this.isInch ? 72 : 1)).toFixed(2);
        const bottom = (itemBottom / (this.isInch ? 72 : 1)).toFixed(2);
        sd.push(top);
        sd.push(bottom);
        sd.push(((parseFloat(top) + parseFloat(bottom)) / 2).toFixed(2));
      });
      console.log(sd);
      return sd;
    },
    loadHorizontalSnapPoints() {
      if (this.contentList.length < 1) {
        return [];
      }
      const elem = this.contentList;
      const sd   = [];
      elem.forEach((item) => {
        let itemLeft  = item.X;
        let itemRight = item.X + item.Width;
        if (item.type == 'text') {
          const normalWidth = item.Width;
          const scaledWidth = item.Width * item.scaleX;
          itemLeft          = item.X - (scaledWidth - normalWidth) / 2;
          itemRight         = itemLeft + (item.Width * item.scaleX);
        }
        const left  = (itemLeft / (this.isInch ? 72 : 1)).toFixed(2);
        const right = (itemRight / (this.isInch ? 72 : 1)).toFixed(2);

        sd.push(right);
        sd.push(left);
        sd.push(((parseFloat(left) + parseFloat(right)) / 2).toFixed(2));
      });

      // console.log(sd);
      return sd;
    },

    getHorizontalGuideStyle() {
      return { background: '#4AFFFF', height: '2px' };
    },
    getVerticalGuideStyle() {
      return { background: '#4AFFFF', width: '2px' };
    },
    getDragGuideStyle() {
      return { background: '#4AFFFF' };
    },
    getDigit() {
      return this.$store.getters.getIsUnitInInch ? 2 : 0;
    },
    isInch() {
      return this.$store.getters.getIsUnitInInch;
    },
    getHSStyle() {
      return {
        height:   '20px', position: 'absolute', top:      '0px', width:    '100%', left:     '20px',
      };
    },
    getRulerUnit() {
      return (this.isInch) ? Math.ceil(1 / (this.$store.getters.getZoomLevel / 100)) : Math.ceil(50 / (this.$store.getters.getZoomLevel / 100));
    },
    getRulerZoom() {
      return (this.isInch) ? (this.$store.getters.getZoomLevel / 100) * 72 : (this.$store.getters.getZoomLevel / 100);
    },
    getZoom() {
      return this.$store.getters.getZoomLevel;
    },
    getStyle() {
      const selectedItems = this.contentList.filter(elem => elem.isSelected);
      console.log(selectedItems.length);
      return {
        '--moveable-ew-opacity':     this.$store.getters.getEWHandle,
        '--moveable-ns-opacity':     this.$store.getters.getNSHandle,
        '--moveable-ns-visibility':  (this.$store.getters.getNSHandle) ? 'visible' : 'hidden',
        '--moveable-ew-visibility':  (this.$store.getters.getEWHandle) ? 'visible' : 'hidden',
        '--moveable-pointer-events': (selectedItems && selectedItems.length > 1) ? 'all' : 'none',
      };
    },
    productPages: {
      get() {
        return this.ProductPagesLength ? this.product.pages : 0;
      },
      set(value) {
        EventBus.$emit('updateProductPagesOrder', value);
        if (this.activePage === this.selectedPagePreviousIndex) {
          this.changeProductPage(this.selectedPageFutureIndex + 1);
        } else if (this.activePage === this.selectedPageFutureIndex) {
          if (this.activePage < this.selectedPagePreviousIndex) {
            this.changeProductPage(this.activePage + 2);
          } else {
            this.changeProductPage(this.activePage);
          }
        } else if (this.selectedPagePreviousIndex < this.activePage && this.selectedPageFutureIndex > this.activePage) {
          this.changeProductPage(this.activePage);
        } else if (this.selectedPagePreviousIndex > this.activePage && this.selectedPageFutureIndex < this.activePage) {
          this.changeProductPage(this.activePage + 2);
        }
        EventBus.$emit('updatePageWiseUndoRedoArray', this.selectedPageFutureIndex, this.selectedPagePreviousIndex);
      },
    },
    getProductPages() {
      return this.ProductPagesLength ? this.product.pages : 0;
    },
    getProductPagesForThumbnail() {
      if (this.ProductPagesLength) {
        const toReturn = _.cloneDeep(this.product.pages);
        toReturn.forEach((page, index) => {
          page.objectList.forEach((item) => {
            item.Id += 'thumbnail-';
          });
        });
        return toReturn;
      }
      return 0;
    },
    getSelectedPageWidth() {
      const { AllowCropping, XCrop } = this.productCrop;
      return AllowCropping ? this.width - XCrop : this.width;
    },
    getSelectedPageHeight() {
      const { AllowCropping, YCrop } = this.productCrop;
      return AllowCropping ? this.height - YCrop : this.height;
    },
    getActivePageIndex() {
      return this.activePage;
    },
    getSelectedPageObjectList() {
      return this.contentList;
    },
    getCanvasWrapperStyle() {
      let style = {};
      if (this.isMounted) {
        const canvasWidth = this.$refs.canvasSection.clientWidth;
        const width       = this.getSelectedPageWidth * this.getZoom / 100;
        const height      = this.getSelectedPageHeight * this.getZoom / 100;

        style = { position: 'absolute', width: `${width}px`, height: `${height}px` };

        let translateX   = '-50%';
        const translateY = '0';
        if (width > canvasWidth) {
          style.left  = '10px';
          style.right = '10px';
          translateX  = '0';
        }
        style.transform = `translate(${translateX},${translateY})`;
        return style;
      }
      return style;
    },
    getCanvasWrapperStyleVideo() {
      let style = {};
      if (this.isMounted) {
        const canvasWidth = this.$refs.canvasSection.clientWidth;
        const width       = this.getSelectedPageWidth * this.getZoom / 100;
        const height      = this.getSelectedPageHeight * this.getZoom / 100;

        style = { position: 'absolute', width: `${width}px`, height: `${height}px` };

        let translateX   = '0px';
        const translateY = '0';
        if (width > canvasWidth) {
          style.left  = '10px';
          style.right = '10px';
          translateX  = '0';
        }
        style.transform = `translate(${translateX},${translateY})`;
        return style;
      }
      return style;
    },
    videoWidth() {
      return this.pages[0].width;
    },
    videoHeight() {
      return this.pages[0].height;
    },
    pages() {
      return this.product.pages;
    },
  },
  watch: {
    // sliderTwo(oldValue, newValue) {
    //   console.log('oldValue, newValue');
    //   console.log(oldValue, newValue, this.sliderOne);
    //   if (Number(newValue) <= Number(this.sliderOne) + 2) {
    //     this.sliderTwo = oldValue;
    //   }
    // },
  },
  mounted() {
    this.isMounted = true;
    window.addEventListener('mousemove', this.resizeAccordingToClientX);
    window.addEventListener('mouseup', this.toggleMouseUpVariable);
    this.$nextTick(() => {
      this.$refs.canvasSection.scrollTop  = this.$store.getters.getScrollPosition.top;
      this.$refs.canvasSection.scrollLeft = this.$store.getters.getScrollPosition.left;
    });
    window.onresize = this.adjustCanvasScaleAccordingToWindowsSize;
    this.calculateAllPagesDuration();
    this.pagesScroll      = document.getElementById('thumbnail-scroller');
    this.canvasPanelWidth = document.getElementById('canvas-section').clientWidth;
    EventBus.$on(ApplicationEventTypes.AnimationEvent.STOP_OBJECT_ANIMATION, this.StopVideoOnCanvas);
    EventBus.$on(ApplicationEventTypes.TransitionEvents.PREVIEW_TRANSITION, this.playAllAnimationOnCanvas);
    EventBus.$on('SetPageVideoLength', this.setPageVideoLength);
    EventBus.$on(ApplicationEventTypes.ProductPageEvents.UPDATE_PRODUCT_PAGES_DURATION, this.calculateAllPagesDuration);
  },
  beforeDestroy() {
    EventBus.$off(ApplicationEventTypes.AnimationEvent.STOP_OBJECT_ANIMATION, this.StopVideoOnCanvas);
    EventBus.$off(ApplicationEventTypes.TransitionEvents.PREVIEW_TRANSITION, this.playAllAnimationOnCanvas);
    EventBus.$off('SetPageVideoLength', this.setPageVideoLength);
    EventBus.$off(ApplicationEventTypes.ProductPageEvents.UPDATE_PRODUCT_PAGES_DURATION, this.calculateAllPagesDuration);
  },
  updated() {
    if (this.$store.getters.getZoomLevel == 0 && this.width > 0) {
      this.adjustCanvasScaleAccordingToWindowsSize();
    }

    setTimeout(this.updateGuidesPosition, 10);
    this.updateGuidesWithUnit();
    this.pagesScroll && this.pagesScroll.scroll({
      left:     this.$store.getters['activeProduct/getSliderScroller'],
      behavior: 'auto',
    });
    if (this.$store.getters['activeProduct/getIsNewPageAdded']) {
      this.pagesScroll.scroll({ left: this.pagesScroll.scrollWidth, behavior: 'smooth' });
      this.$store.commit('activeProduct/updateIsNewPageAdded', false);
    }
  },
  onMounted() {
    console.log('Mounted');
  },
  methods: {
    playAnimationBeforeVideoScrubbing(transition = {}) {
      const self      = this;
      this.$store.commit('activeProduct/updateSliderScroller', 0);
      this.timeLineOffset = 0;
      setTimeout(() => {
        _.isEmpty(transition) && EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.CLEARED);
        self.displayThumbnailOptions = false;
        self.playVideo(transition, true);
      });
    },
    updateSceneTime() {
      const totalWidth = this.product.pages.reduce((sum, page) => sum + page.animation.timeLineWidth, 0) + (this.product.pages.length - 1) * 20;
      const timePercentage = (this.timeLine / totalWidth) * 100;
      this.sceneO.setTime(`${timePercentage}%`);
    },
    onMouseDown(event) {
      if (!this.sceneO) {
        this.playAnimationBeforeVideoScrubbing();
      } else {
        if (!this.$store.getters['activeProduct/getShowVideoPanel']) {
          EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.CLEARED);
          this.$store.commit('activeProduct/updateShowVideoPanel', true);
        }
      }
      this.isDragging        = true;
      this.startX            = event.clientX;
      this.isMouseDown       = true;

      document.addEventListener('mousemove', this.onMouseMove);
      document.addEventListener('mouseup', this.onMouseUp);
    },
    onMouseMove(event) {
      if (!this.isDragging) return;

      const slidesWrapper = document.querySelector('.slides-wrapper');
      const progressBarWrapper = document.querySelector('.progress-bar-wrapper');
      const slidesRect = slidesWrapper.getBoundingClientRect();

      // Check if cursor is inside slides-wrapper
      if (event.clientX < slidesRect.left || event.clientX > slidesRect.right) {
        return;
      }

      const deltaX = event.clientX - this.startX;
      this.startX  = event.clientX;

      const maxTranslateX = slidesWrapper.clientWidth - progressBarWrapper.clientWidth;
      let newTranslateX = this.timeLine + deltaX;
      newTranslateX = Math.max(1, Math.min(newTranslateX, maxTranslateX));

      this.timeLine = newTranslateX;
      this.updateSceneTime();
    },
    /*onMouseMove(event) {
      if (!this.isDragging) { return; }
      const deltaX = event.clientX - this.startX;
      this.startX  = event.clientX;

      const slidesWrapper      = document.querySelector('.slides-wrapper');
      const progressBarWrapper = document.querySelector('.progress-bar-wrapper');

      const maxTranslateX = slidesWrapper.clientWidth - progressBarWrapper.clientWidth;
      let newTranslateX   = this.timeLine + deltaX;

      if (newTranslateX < 1) {
        newTranslateX = 1;
      } else if (newTranslateX > maxTranslateX) {
        newTranslateX = maxTranslateX;
      }

      this.timeLine = newTranslateX;

      this.updateSceneTime();
    },*/
    onMouseUp() {
      const totalWidth = this.product.pages.reduce((sum, page) => sum + page.animation.timeLineWidth, 0) + (this.product.pages.length - 1) * 20;
      const timePercentage = (this.timeLine / totalWidth) * 100;
      this.$store.commit('updateTimeLinePercentage', timePercentage);

      this.isDragging  = false;
      this.isMouseDown = false;
      document.removeEventListener('mousemove', this.onMouseMove);
      document.removeEventListener('mouseup', this.onMouseUp);
    },

    onMouseEnter() {
      if (!this.mouseDown) {
        this.dragging = false;
      }
    },
    onMouseLeave() {
      if (!this.mouseDown) {
        this.dragging = true;
      }
    },
    onDragMove($event) {
      this.selectedPageFutureIndex   = $event.draggedContext.futureIndex;
      this.selectedPagePreviousIndex = $event.draggedContext.index;
    },
    toggleAnimationTray() {
      this.$store.commit('activeProduct/updateDisplayAnimationPanel', !this.$store.getters['activeProduct/getDisplayAnimationPanel']);
    },
    getTrimmingBarStyle() {
      let s = this.canvasPanelWidth - 160;

      s                     /= this.activeObject.videoDetails.duration;
      const l                = this.sliderTwo * s;
      this.trimBar           = l;
      this.trimBarTransition = `left ${parseFloat(this.sliderTwo) - parseFloat(this.sliderOne)}s linear`;
    },
    stopSelectedVideo(e) {
      this.$store.commit('activeProduct/updateIsTrimmedVideoPlaying', false);
      this.selectedVideo && this.selectedVideo.pause();
      this.selectedAudio && this.selectedAudio.pause();

      let s    = this.canvasPanelWidth - 160;
      s       /= this.activeObject.videoDetails.duration;
      let l    = this.sliderOne * s;
      const l2 = this.sliderTwo * s;
      if (l > (l2 - (s / 1.5))) {
        l = l2 - (s / 1.5);
      }
      this.trimBar           = this.sliderOne * s;
      this.trimBarTransition = '';
      clearTimeout(this.trimInterval);
    },
    playSelectedVideo() {
      this.stopSelectedVideo();
      setTimeout(() => {
        if (this.activeObject) {
          this.selectedVideo = document.querySelector(`#video${this.activeObject.Id}`);
          if (!this.selectedVideo.innerHTML.includes('audio')) {
            this.selectedVideo.innerHTML += `<audio><source src="${this.activeObject.videoDetails.audio}" type="audio/mp3"></audio>`;
          }
          this.selectedAudio             = document.querySelector(`#video${this.activeObject.Id} audio`);
          this.selectedVideo.currentTime = this.sliderOne;
          this.selectedAudio.currentTime = this.sliderOne;
          this.selectedVideo.play();
          this.selectedAudio.play();
          this.selectedVideo.addEventListener('playing', () => {
            this.$store.commit('activeProduct/updateIsTrimmedVideoPlaying', true);
          });
          this.getTrimmingBarStyle();

          const duration    = (parseFloat(this.sliderTwo) - parseFloat(this.sliderOne)) * 1000;
          this.trimInterval = setTimeout(() => {
            this.stopSelectedVideo();
          }, duration);
        }
      }, 20);
    },
    trimVideo() {
      this.$store.commit('activeProduct/updateISTrimmingEnable', false);
      if (!this.activeObject) {
        return;
      }
      const st = `${parseFloat(this.sliderOne).toFixed(2)}0`;
      const et = `${parseFloat(this.sliderTwo).toFixed(2)}0`;
      console.log(st, et);
      EventBus.$emit(ApplicationEventTypes.Video.TRIM_VIDEO, { startTime: st, endTime: et });
      EventBus.$emit(ApplicationEventTypes.UndoRedoEvents.ADDED, 'called by video object trimming');
    },
    slideOne(e) {
      this.stopSelectedVideo(e);
      if (this.sliderTwo - this.sliderOne <= this.getSliderGap) {
        this.sliderOne = this.sliderTwo - this.getSliderGap;
      }
    },
    slideTwo(e) {
      this.stopSelectedVideo(e);
      if (this.sliderTwo - this.sliderOne <= this.getSliderGap) {
        this.sliderTwo = this.sliderOne + this.getSliderGap;
      }
    },
    updatedScrollingValue() {
      this.timeLineOffset = this.pagesScroll.scrollLeft;
      this.$store.commit('activeProduct/updateSliderScroller', this.pagesScroll.scrollLeft);
    },
    threeDotsApperance(index) {
      const newStyle = {
        left:   `${this.threeDotLeft - this.threeDotsLeftOffset}px`,
        bottom: `${120}px`,
      };
      return newStyle;
    },
    addTransitionToPage(index) {
      this.clearAllSelection();
      this.$store.commit('activeProduct/updatePageAnimationIndex', index);
      this.$store.commit('activeProduct/updatePageAnimationPanel', true);
      this.$store.commit('activeProduct/updateDisplayAnimationPanel', true);
      this.displayThumbnailOptions = false;
    },
    transitionIconToShow(index) {
      return (index < this.product.pages.length - 1);
    },
    showThreeDots(e) {
      this.displayThumbnailOptions = !this.displayThumbnailOptions;
      this.threeDotLeft            = e.x;
      this.threeDotTop             = e.y;
    },
    onCanvasClickToStopAnimation() {
      if (this.$store.getters['activeProduct/getShowVideoPanel']) {
        this.$store.commit('activeProduct/updateShowVideoPanel', false);
        this.stopVideo();
      }
    },
    pauseVideoOnCanvas() {
      this.sceneO.isPaused() ? this.sceneO.play() : this.sceneO.pause();
      this.$store.commit('activeProduct/setIsAnimationInProgress', false);
      this.isVideoPaused = this.sceneO.isPaused();
    },
    StopVideoOnCanvas() {
      this.displayThumbnailOptions = false;
      this.stopVideo();
      this.timeLine = 0;
      for (let i = 0; i < this.videoObjPlayingTiemouts.length; i++) {
        clearTimeout(this.videoObjPlayingTiemouts[i]);
      }
    },
    playAllAnimationOnCanvas(transition = {}) {
      if (this.sceneO && this.sceneO.getTime() > 0 && this.sceneO.isPaused()){
        this.moveProgressBar();
        this.$store.commit('activeProduct/setIsAnimationInProgress', true);
        this.displayThumbnailOptions = false;
        this.sceneO.play();
      } else {
        EventBus.$emit('showHideLoader', true);
        this.rerenderer = this.rerenderer + 1;
        const self      = this;
        this.$store.commit('activeProduct/updateSliderScroller', 0);
        this.timeLineOffset = 0;
        setTimeout(() => {
          _.isEmpty(transition) && EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.CLEARED);
          self.displayThumbnailOptions = false;
          self.playVideo(transition);
        });
      }
    },
    moveProgressBar() {
      const duration   = this.productDuration;
      let currentWidth = this.timeLine;
      this.interval    = setInterval(() => {
        if (this.timeLine + 70 > (this.pagesScroll.clientWidth + this.timeLineOffset)) {
          this.timeLineOffset += 1;
          this.pagesScroll.scroll({ left: this.timeLineOffset, behavior: 'smooth' });
          this.$store.commit('activeProduct/updateSliderScroller', this.timeLineOffset);
        }
        console.log("this.played -------------- ", this.played);
        currentWidth  = (this.played / duration) * this.productTimeLineWidth;
        this.timeLine = currentWidth;
        if (currentWidth >= this.productTimeLineWidth) {
          clearInterval(this.interval);
        }
      }, 0);
    },
    getWraperDivStyle() {
      const {
        AllowCropping, XCrop, YCrop, WidthCrop, HeightCrop,
      } = this.productCrop;
      const scaleRatio = this.getZoom / 100;
      const transform  = `scale(${scaleRatio}) `;
      const newStyle   = {
        transform,
        width:            `${this.width}px`,
        height:           `${this.height}px`,
        backgroundColor:  '#ffffff',
        overflow:         'hidden',
        backgroundImage:  `url(${this.baseImage})`,
        backgroundRepeat: 'no-repeat',
        filter:           this.isGrayScaleOn ? 'grayscale(1)' : 'grayscale(0)',
        marginLeft:       AllowCropping ? `${-parseFloat(XCrop * scaleRatio)}px` : '0px',
        marginTop:        AllowCropping ? `${-parseFloat(YCrop * scaleRatio)}px` : '0px',
        backgroundSize:   `${AllowCropping ? this.width + parseFloat(XCrop) : this.width}px ${AllowCropping ? this.height + parseFloat(YCrop) : this.height}px`,
      };
      return newStyle;
    },
    calculateAllPagesDuration() {
      let totalSeconds          = 0;
      this.productTimeLineWidth = 0;
      this.thumbnailScroller    = 0;
      if (this.product) {
        for (let i = 0; i < this.product.pages.length; i++) {
          if (this.product.pages[i].animation) {
            this.productTimeLineWidth += this.product.pages[i].animation.timeLineWidth;
            this.productTimeLineWidth += this.product.pages.length - 1 > i ? 20 : 0;
            totalSeconds              += parseFloat(this.product.pages[i].animation.duration);
          } else {
            this.productTimeLineWidth += 300;
            this.productTimeLineWidth += this.product.pages.length - 1 > i ? 20 : 0;
            totalSeconds              += 5;
          }
        }
        this.thumbnailScroller = this.productTimeLineWidth;
        this.productDuration   = totalSeconds;
      }
      return 0;
    },
    getPageDuration(page) {
      if (page && page.animation && page.animation.duration) {
        return `${parseFloat(page.animation.duration).toFixed(1)}s`;
      }
      return '5.0s';
    },
    getThumbnailStyle(index) {
      const newStyle = {
        width:  '100%',
        border: this.activePage == index ? '2px solid #3bb0fa' : '1px solid #D6D6D6',
      };
      return newStyle;
    },
    getParentDivThumbnailStyle(page) {
      const newStyle = {
        width:        `${page.animation && page.animation.timeLineWidth ? page.animation.timeLineWidth : 140}px`,
        borderRadius: '9px',
        overflow:     'visible',
        marginRight:  this.isVideoMoodOn ? '' : '20px',
      };
      return newStyle;
    },
    toggleMouseUpVariable(e) {
      if (!this.mouseDown) { return; }
      const index = this.selectedThumbnailId.split('-')[2];
      if (!index) { return; }

      const page = document.getElementById(`page-${index}`);
      if (!page) { return; }

      if (this.product && this.product.pages[index]) {
        const newProduct      = _.cloneDeep(this.product);
        const durationDiv     = document.getElementById(`duration-${index}`);
        const pixelsPerMinute = 28;
        const duration        = page.offsetWidth / pixelsPerMinute;

        durationDiv.innerText = `${duration.toFixed(1)}s`;

        newProduct.pages[index].animation.timeLineWidth = page.offsetWidth;
        newProduct.pages[index].animation.duration      = duration.toFixed(1);

        EventBus.$emit('updateProductPagesOrder', newProduct.pages);
        this.calculateAllPagesDuration();
        this.timeLine  = 0;
        this.mouseDown = false;
        EventBus.$emit(ApplicationEventTypes.ProductPageEvents.UPDATE_PRODUCT_TRANSITION_OBJECT);
        EventBus.$emit(ApplicationEventTypes.ProductPageEvents.UPDATE_PAGE_UNDO_REDO_OBJ);
        EventBus.$emit(ApplicationEventTypes.UndoRedoEvents.ADDED, 'called by toggleMouseUpVariable');
      }
    },
    resizeAccordingToClientX(e) {
      if (!this.mouseDown) { return; }

      const index = this.selectedThumbnailId.split('-')[2];
      if (!index) { return; }

      const page              = document.getElementById(`page-${index}`);
      const thumbnailTimeline = document.getElementById('thumbnail-timeline');
      if (!page || !thumbnailTimeline) { return; }

      const minPageWidth       = 28;
      const maxPageWidth       = 1260;
      const currentWidth       = page.offsetWidth;
      const timelineTotalWidth = thumbnailTimeline.offsetWidth;
      let newWidth,
        newTimelineTotalWidth;

      if (this.selectedThumbnailId.includes('right')) {
        newWidth              = currentWidth + e.movementX;
        newTimelineTotalWidth = timelineTotalWidth + e.movementX;
      } else {
        newWidth              = currentWidth - Math.abs(e.movementX);
        newTimelineTotalWidth = timelineTotalWidth - Math.abs(e.movementX);
      }

      if (newWidth >= minPageWidth && newWidth <= maxPageWidth) {
        thumbnailTimeline.style.width = `${newTimelineTotalWidth}px`;
        page.style.width              = `${newWidth}px`;
        if (this.pagesScroll.scrollWidth > this.pagesScroll.clientWidth && this.product.pages.length == (parseInt(index) + 1)) {
          this.pagesScroll.scrollLeft += e.movementX;
        } else {
          this.pagesScroll.scrollLeft += e.movementX;
        }
      }

      this.$store.commit('activeProduct/updateSliderScroller', this.pagesScroll.scrollLeft);

      const durationDiv     = document.getElementById(`duration-${index}`);
      const pixelsPerMinute = 28;
      const duration        = newWidth / pixelsPerMinute;
      durationDiv.innerText = `${duration.toFixed(1)}s`;
    },
    resizePageWidthStart(e) {
      this.displayThumbnailOptions = false;
      if (this.$store.getters['activeProduct/getShowVideoPanel']) {
        this.$store.commit('activeProduct/updateShowVideoPanel', false);
        this.stopVideo();
      }
      this.mouseDown           = true;
      this.selectedThumbnailId = e.target.id;
    },

    getScale(page, pageWidth, pageHeight) {
      return `scale(${this.calculatedScale(page, pageWidth, pageHeight).x},${this.calculatedScale(page, pageWidth, pageHeight).y})`;
    },
    calculatedScale(page, pageWidth, pageHeight) {
      const scale = {
        x: pageWidth / page.width,
        y: pageHeight / page.height,
      };
      return scale;
    },

    getHTMLStyle(page) {
      const newStyle = {
        backgroundColor:  '#ffffff',
        backgroundImage:  `url(${this.baseImage})`,
        backgroundRepeat: 'no-repeat',
        filter:           this.isGrayScaleOn ? 'grayscale(1)' : 'grayscale(0)',
        width:            `${page.width}px`,
        height:           `${page.height}px`,
        transformOrigin:  'left top',
        overflow:         'hidden',
      };
      return newStyle;
    },

    calculateDimensions(page) {
      let pageHeight    = 80;
      let pageWidth     = 80;
      const aspectRatio = page.width / page.height;
      if (parseInt(page.width) < parseInt(page.height)) {
        pageWidth = pageHeight * aspectRatio;
      } else if (parseInt(page.width) > parseInt(page.height)) {
        pageWidth  = 80;
        pageHeight = pageWidth / aspectRatio;
      } else {
        pageHeight = 80;
        pageWidth  = 80;
      }
      const scaleX       = pageWidth / page.width;
      const scaleY       = pageHeight / page.height;
      const borderRadius = 7 / this.calculatedScale(page, pageWidth, pageHeight).x;
      const style        = {
        transform:    `scaleX(${scaleX}) scaleY(${scaleY})`,
        width:        `${page.width}px`,
        height:       `${page.height}px`,
        borderRadius: `${borderRadius}px`,
        position:     'relative',
      };
      return style;
    },

    updateGuidesPosition() {
      if (this.$refs.canvasSection && this.$refs.hGuides && !this.$store.getters['activeProduct/getShowVideoPanel']) {
        let hPos = (this.$refs.canvasSection.getBoundingClientRect().x + 20) - this.$refs.canvasWrapper.getBoundingClientRect().x;
        hPos    /= (this.$store.getters.getZoomLevel / 100);
        let yPos = (this.$refs.canvasSection.parentElement.getBoundingClientRect().y + 20) - this.$refs.canvasWrapper.getBoundingClientRect().y;
        yPos    /= (this.$store.getters.getZoomLevel / 100);

        this.scrollHorizontalRuler({ x: hPos, y: yPos });
        this.scrollVerticalRuler({ x: hPos, y: yPos });
      }
    },
    onChangeGuides() {
      const vGuidelines = (this.isInch) ? this.$refs.vGuides.getGuides().map(num => Math.round(num * 72)) : this.$refs.vGuides.getGuides();
      const hGuidelines = (this.isInch) ? this.$refs.hGuides.getGuides().map(num => Math.round(num * 72)) : this.$refs.hGuides.getGuides();
      this.$store.commit('setVerticalGuides', vGuidelines);
      this.$store.commit('setHorizontalGuides', hGuidelines);
    },
    updateGuidesWithUnit() {
      // this.isInch = unit == 'Inches';
      if (this.$refs.vGuides) {
        const vGuidelines = this.$store.getters.getVerticalGuides;
        const hGuidelines = this.$store.getters.getHorizontalGuides;
        if (this.isInch == true) {
          this.$refs.vGuides.loadGuides(vGuidelines.map(num => num / 72));
          this.$refs.hGuides.loadGuides(hGuidelines.map(num => num / 72));
        } else {
          this.$refs.vGuides.loadGuides(vGuidelines);
          this.$refs.hGuides.loadGuides(hGuidelines);
        }
      }
    },

    getZoomToFit() {
      const widthRatio  = (this.$refs.canvasSection.clientWidth - 40) / this.getSelectedPageWidth;
      const heightRatio = (this.$refs.canvasSection.clientHeight - 20) / this.getSelectedPageHeight;
      if (heightRatio < widthRatio) {
        return heightRatio * 100.0;
      }
      return widthRatio * 100.0;
    },
    onProductNewPageCreate() {
      this.$store.commit('activeProduct/updateIsNewPageAdded', true);
      if (this.$store.getters['activeProduct/getShowVideoPanel']) {
        this.$store.commit('activeProduct/updateShowVideoPanel', false);
        this.stopVideo();
      }
      this.clearAllSelection();
      setTimeout(() => {
        EventBus.$emit('productNewPageCreate');
      }, 100);
    },
    onProductPageDuplicate(page) {
      this.clearAllSelection();
      this.thumbnailScroller += (page.animation && page.animation.duration) ? page.animation.duration * 24 : (5 * 24);
      setTimeout(() => {
        EventBus.$emit('productPageDuplicate');
      }, 100);
      setTimeout(() => {
        this.calculateAllPagesDuration();
      }, 200);
    },
    deleteCurrentProductPage() {
      EventBus.$emit(ApplicationEventTypes.ModalEvents.TOGGLE_CONFIRMATION_MODAL, {
        request: 'DeletePageRequest',
        message: 'Are you sure you want to delete this page?',
      });
      // this.clearAllSelection();
      // EventBus.$emit('onDeleteProductPage');
    },
    changeProductPage(pageIndex) {
      this.$store.commit('activeProduct/updateSliderScroller', this.pagesScroll.scrollLeft);
      this.clearAllSelection();
      /* this.$store.commit('updateZoomLevel', this.zoomToFitLevel); */
      this.$store.commit('updateCanvasScroll', { top: 0, left: 0 });
      setTimeout(() => {
        pageIndex -= 1;
        EventBus.$emit('onChangeProductPage', pageIndex);
      }, 100);
    },
    canvasWrapper() {
    },
    adjustCanvasScaleAccordingToWindowsSize() {
      this.zoomToFitLevel = this.getZoomToFit();
      this.$store.commit('updateZoomLevel', this.zoomToFitLevel);
    },
    clearAllSelection(e, f) {
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.CLEARED);
      EventBus.$emit('toggleAudioLeftSectionAccordion', false);
      console.log(e, f);
    },

    savePageScroll(e) {
      this.updateGuidesPosition();
      this.$store.commit('updateCanvasScroll', {
        top:  this.$refs.canvasSection.scrollTop,
        left: this.$refs.canvasSection.scrollLeft,
      });
    },

    zoomInCanvas(e) {
      this.$store.commit('updateZoomLevel', this.getZoom + 10);
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.ZOOM_CHANGE, { zoomLevel: this.getZoom });
      e.stopPropagation();
    },

    zoomOutCanvas(e) {
      this.$store.commit('updateZoomLevel', this.getZoom - 10);
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.ZOOM_CHANGE, { zoomLevel: this.getZoom });
      e.stopPropagation();
    },
    scrollHorizontalRuler(positionOffset) {
      const { hGuides, vGuides } = this.$refs;
      const newPos               = (this.isInch) ? positionOffset.x / 72 : positionOffset.x;
      hGuides.scroll(newPos);
      vGuides.scrollGuides(newPos);
    },
    scrollVerticalRuler(positionOffset) {
      const { hGuides, vGuides } = this.$refs;
      const newPos               = (this.isInch) ? positionOffset.y / 72 : positionOffset.y;
      vGuides.scroll(newPos);
      hGuides.scrollGuides(newPos);
    },
    resetZoom(e) {
      this.$store.commit('updateZoomLevel', this.getZoomToFit());
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.ZOOM_CHANGE, { zoomLevel: this.getZoomToFit });
      e.stopPropagation();
    },

    setPageVideoLength(duration) {
      if (parseFloat(duration) > this.product.pages[this.activePage].animation.duration) {
        EventBus.$emit(ApplicationEventTypes.ProductPageEvents.PAGE_DURATION_UPDATE, duration);
      }
    },
  },
};

</script>
<style>
.rCS1g1q24i .scena-guides-guides .scena-guides-guide {
  background-color: #74ffff;
}
</style>
<style lang="scss" scoped>
#hRuler {
  position: absolute;
  width: 100%;
  height: 20px;
  top: 0px;
  padding-left: 32px;
  background: rgba(255, 255, 255, 0.7);
  z-index: 999;
}

#vRuler {
  position: absolute;
  width: 20px;
  height: 100%;
  top: 0px;
  background: rgba(255, 255, 255, 0.7);
  padding-top: 32px;
  z-index: 999;
}

.rulez-rect {
  fill: #EDEDED;
}

.rulez-text {
  fill: #DDDDDD;
}

.rulez-rect-h {
  transform: scale(1, -1);
  transform-origin: center;
}

.rulez-text {
  position: absolute;
  width: 5px;
  height: 10px;
  left: 10px;
  top: 3px;

  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 8px;
  line-height: 10px;
}

.pagination-list .figma-icon {
  .icon {
    min-height: auto;
    min-width: auto;
  }

  svg {
    height: 28px;
    width: 28px;

    &:hover {
      filter: none !important;
    }
  }
}

.flex-center-panel {
  background-color: $grey20;
  max-height: calc(100vh - 68px);
  max-width: none;
}

.updated-flex {
  flex: 0 0 60px;
}

.pagination-section {

  .pagination-pill {
    @include FontVariation(1.2rem, 600, Open Sans, $grey70);
    line-height: 2.0rem;
    min-width: 28px;
    height: 28px;
    cursor: pointer;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.04);

    &:hover {
      color: $grey90 !important;
    }

    &:active {
      color: $blue50;
    }

    &:disabled {
      cursor: default !important;
      pointer-events: none;
      color: $grey40;

      &:hover {
        color: $grey40 !important;
      }
    }
  }

  &.thumbnail-area {
    height: 135px;
    z-index: 1;

    .pagination-button-wrapper {
      width: 120px;
      height: 84px;
      text-align: center;
      background-color: #D6D6D6;
      display: flex;
      align-items: center;
      justify-content: center;
      // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.4), 0px 0px 2px rgba(0, 0, 0,  0.6), 0px 0px 1px rgba(0, 0, 0,  0.4);
      border-radius: 7px;

      .pagination-pill {
        box-shadow: none

      }

      &.page-plus {
        width: 78px;
        background-color: #D6D6D6;
        box-shadow: none;

        .pagination-pill {
          background-color: transparent;
        }
      }
    }
  }

}


.icon-btn {
  @extend .pagination-pill;
  width: 28px;

  &:disabled {
    cursor: default !important;
    border: 1px solid $grey20 !important;

    &:hover {
      stroke: $grey40 !important;

      svg {
        path {
          stroke: $grey40 !important;
        }
      }

    }

    svg {
      path {
        stroke: $grey40;
      }
    }

    &.dotted-border {
      border: 1px dashed $grey40 !important;
    }
  }
}

.zoom-button-section {
  flex: 0 0 70px;

  .pagination-pill {
    @extend .pagination-pill;
    @include paginationPills(36px, 36px);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.04);
  }
}

.canvas-section {
  flex: 1 1 auto;
  scrollbar-gutter: stable;

  .canvas-wrapper {
    left: 50%;
    top: 0px;
    transform: translate(-50%, 0);

    .html-container {
      transform-origin: top left;
    }
  }
}

.zoom-button-section {
  .pagination-pill {
    &.enable-zoom {
      svg {
        path {
          stroke: $grey80;
        }
      }
    }

    &.disabled {
      pointer-events: none;
      cursor: default;
    }
  }
}

.dotted-border {
  .pagination-pill {
    border: 1px dashed $grey80 !important;
  }
}

.dotted-border {
  &.pagination-pill {
    border: 1px dashed $grey80 !important;
  }
}


.canvas-wrapper {
  cursor: url('../../assets/images/layer-hover.png'), auto !important;

}

.tooltip-button {
  &:hover {
    .tooltip-wrapper {
    }

    svg {
      filter: invert(0%) sepia(2%) saturate(3238%) hue-rotate(321deg) brightness(92%) contrast(199%);
    }
  }
}


.pagination-buttons {
  min-height: 28px !important;
  height: auto !important;
}

.extra-button {
  position: absolute;
  right: -35px;
  width: 30px;

  &:hover {
    cursor: url('../../assets/images/layer-hover.png'), auto !important;
  }

  .button {
    display: block;
    width: 36px;
    height: 36px;
    padding: 0px;
    background-color: white;
    border-radius: 5px !important;
    border: 1px solid #ededed
  }

  .button .hover-icon {
    pointer-events: none;
  }

}

.dotted-dd {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  border-radius: 14px;
  position: absolute;
  top: 5px;
  right: 12px;
  width: 15px;
  height: 21px;
  background: #bdbdbdde;
  row-gap: 2px;
  z-index: 30;

  &:hover {
    box-shadow: 0px 0px 0px 2px #3bb0fa;
  }


  .dot {
    height: 4px;
    width: 4px;
    background-color: black;
    border-radius: 50%;

  }

  &:hover {
    cursor: pointer;
  }
}

.box-shadow-3dots {
  box-shadow: 0px 0px 0px 2px #3bb0fa;
}

.dots-popup-menu {
  background: #ffffff;
  border-radius: 4px;
  z-index: 2;

  ul {
    padding: 0;
    z-index: 2;
    border-radius: 4px;
    position: relative;

    li {
      display: flex;
      border-radius: 4px;
      justify-content: start;
      align-items: center;
      padding: 6px 12px;
      border: 1px solid rgba(0, 0, 0, 0.05);
      cursor: pointer;

      &:hover {
        background-color: #ededed;
        border-radius: 4px;
      }

      img {
        margin-right: 15px;
      }

      &:last-child {
        border: 0;
      }
    }
  }

  .closer {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
  }
}

.play-btn {
  position: absolute;
  z-index: 11;
  margin-left: 10px;
  background-color: white;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
  border-radius: 50%;
  border: 0.1px solid #ADADAD;
  box-shadow: 0px 4px 50px 3px rgba(0, 0, 0, 0.25);
  cursor: pointer;
}

.container-trim {
  height: 100%;
  width: 100%;

  .trim {
    background: #3bb0fa;
    color: white;
    position: absolute;
    opacity: 0;
    width: 10px;
    height: 84px;
    border: 1px solid #3bb0fa;
    cursor: ew-resize !important;
    z-index: 10;
    transition: bottom 0.3s;
    font-size: 20px;

    &:hover {
      opacity: 0.7;
    }
  }

  .left {
    left: 0;
  }

  .right {
    right: 0;
  }
}

.page-duration {
  display: flex;
  justify-content: center;
  position: absolute;
  right: 3px;
  bottom: 5px;
  font-size: 10px;
  font-weight: 800;
}

.timeline-duration {
  margin-left: 20px;
  margin-bottom: 0;
  font-size: 12px;
  font-weight: 800;
}

.slider-line {
  background-color: #252627;
  border-radius: 3px;
  z-index: 10;
}

.transition-icon {
  border: 2px solid #3bb0fa;
  border-radius: 4px;
  opacity: 0;

  &:hover {
    opacity: 1;
  }

  &.full-opacity {
    opacity: 1;
  }

  .icon {
    cursor: pointer;

    svg {
      border-radius: 12px;
      transform: scale(1.5);
      z-index: 10;

    }
  }
}

#thumbnail-scroller {
  &::-webkit-scrollbar {
    height: 8px;
    border: 1px solid $grey20;
    border-radius: 4px
  }
}

.trim-parent {
  display: flex;
  gap: 0 20px;
}

.trimming-container {
  display: flex;
}

.wrapper {
  position: absolute;
  width: 100%;
  border: 2px solid rgb(59, 176, 250);
  border-radius: 7px;
}

.container-trimming {
  display: flex;
  position: relative;
  width: 100%;
  height: 80px;
}

input[type="range"] {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 100%;
  height: 80px;
  outline: none;
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  cursor: ew-resize;
  position: absolute;

  &:focus {
    border: none;
  }

  &::-webkit-slider-thumb,
  &::-moz-range-thumb {
    -webkit-appearance: none;
    height: 80px;
    width: 10px;
    background-color: #3bb0fa;
    cursor: ew-resize;
    pointer-events: auto;
    border-radius: 2px;
    border: 2px solid #3bb0fa;
  }
}

input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  height: 80px;
  width: 10px;
  background-color: #3bb0fa;
  cursor: ew-resize;
  pointer-events: auto;
  border-radius: 2px;
  border: 2px solid #3bb0fa;
}

input[type="range"]:active::-webkit-slider-thumb {
  background-color: #3bb0fa;
}

.trim-btn {
  z-index: 10;
  margin-left: 10px;
  background-color: white;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 0.1px solid #ADADAD;
  box-shadow: 0px 4px 50px 3px rgba(0, 0, 0, 0.25);
  cursor: pointer;
}

.trim-overlay {
  background: white;
  opacity: 0.5;
  top: 0;
  bottom: 0;
}

.startTime {
  position: absolute;
  left: 0;
}

.endTime {
  position: absolute;
  right: 0;
}

.trim-timeline {
  position: absolute;
  background-color: #3bb0fa;
  width: 35px;
  top: -25px;
  padding: 2px 0;
  border-radius: 5px;
  text-align: center;
  font-weight: 300;
  font-size: 12px;
  color: #ffffff;
  opacity: 0.7;
}

.trim-timeline-start {
  left: -5px;
}

.trim-timeline-end {
  right: -5px;
}

.trim-duration {
  bottom: 5px;
  margin-left: 20px;
  font-size: 12px;
  font-weight: 800;
}

.trim-bar {
  background-color: #252627;
  border-radius: 3px;
  z-index: 10;
}

.animation-button {
  border: 0;
  cursor: pointer;
  background-color: white;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.04);
  border-radius: 4px;
  margin-left: 12px;
  padding-left: 8px;
  border: 2px solid white;
}

.selected-animation {
  border: 2px solid #3bb0fa;
}

.svg-img-shapes {
  svg {
    width: auto !important;
    height: auto !important;
  }
}

.static-pages {
  margin-left: 76px;
}

.addition-setting {
  margin-left: 14px;
}

.translate-0-imp {
  transform: translate(0) !important;
}

.opacity-dim {
  opacity: 0.6;
}

#canvas-audio {
  height: 0;
  widows: 0;
}
.grabbing {
  cursor: grabbing !important;
}
</style>
